<input
  #input="ngModel"
  type="text"
  [(ngModel)]="query"
  placeholder="{{ placeHolder | translate }}"
/>
